import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProjectConfiguration } from '../services/getProjectConfiguration.service';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

export const loadProjectConfiguration = createAsyncThunk(
  'projectConfigurations/loadProjectConfiguration',
  async (_, { getState }) => {
    const projectId = selectSelectedProjectId(getState());
    if (!projectId) {
      return null;
    }
    const projectConfiguration = await getProjectConfiguration(projectId);

    return {
      projectId,
      projectConfiguration,
    };
  }
);
